import Layout from "./Layout";
import { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

const Afiliates = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation();
   function copy(text) {
    toast.success("Link Copied!");
    return window.navigator.clipboard.writeText(text);
  }

  return (
    <Layout>
      <div className="full-width">
        <div
          className={`col col-12 ${isMobile ? "px-2" : "px-5"}  register_panel`}
        >
          <div className="row hidden-md-and-up">
            <div className="mobile-header text-center col col-12">
              Agent Affiliate Link
            </div>
          </div>
          <div
            className="row hidden-sm-and-down mt-2"
            style={{ margin: "unset" }}
          ></div>

          <div
            className={`row justify-center ${
              isMobile ? "hidden-md-and-up" : "mt-2 hidden-sm-and-down mb-4"
            } `}
          >
            <div className="col col-12">
              <div className="v-window v-item-group theme--light ma-8">
                <div className="v-window__container">
                  <div className="v-window-item v-window-item--active">
                    <div className="referal_liks_top">
            <p>
              {"Agent Login Link"} -{" "}
              <a
                target="_blank"
                href={`https://ag.${window.location.hostname.replace(/^(www|ag|msa|bxawscf|velki|aff)\./, "")}/`}
               
              >
                https://ag.{`${window.location.hostname.replace(/^(www|ag|msa|bxawscf|velki|aff)\./, "")}/`}/{" "}
              </a>
            </p>
            <p>
              {"Refer Link"} -{" "}
              <span
                onClick={() => {
                  copy(`${window.location.origin}/affiliateLink${search}`);
                }}
                
              >{`${window.location.origin}/affiliateLink${search}`}</span>
            </p>
          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Afiliates;
